<template>
<v-card tile height="100%" >
  <guide-toolbar small
    title="Help clients find your business"
    @selected="setContext" />
  <v-divider />
  <v-card-text >
    <ul>
      <li>Make sure that your clients have all the information they need to easily find your business.</li>
      <li>Here you can see you locations and make sure that you have added all the information you clients will need to find you.</li>
      <li v-if="!spaceId" >
        Choose a space above to edit relevant locations for the space
      </li>
    </ul>
  </v-card-text>
  <v-divider/>
  <v-card-title v-if="spaceId" >
    Location for {{space.title}}
    <v-spacer />
    <v-btn small outlined
      @click="launchNewLocationWizard"
      color="primary" >
      <v-icon small >mdi-plus</v-icon>
      Add a new location</v-btn>
  </v-card-title>
  <v-card-text class="grey lighten-4" >
    <request-status :request="req" />
    <v-row>
      <!-- <v-skeleton-loader class="mx-auto" type="card" /> -->
      <v-col
        v-for="(location, index) in locations"
        :key="location.id" cols="12" >
          <v-card flat
            @click="launchLocationForm(spaceId, location.id)" >
            <location-card
              v-model="locations[index]" >
              <v-card-actions slot="card-actions" >
                <v-spacer/>
                <v-btn text >Edit location</v-btn>
              </v-card-actions>
            </location-card>
            <!-- <pre>spaces: {{location}}</pre> -->
          </v-card>
      <!-- <pre v-text="location" /> -->
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
</template>

<script>
import GuideToolbar from '@/components/actions/guides/GuideToolbar.vue'
import LocationCard from '@/components/cards/LocationCard.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'GetFound',
  components: {
    GuideToolbar,
    LocationCard
  },
  data () {
    return {
      space: null,
      req: {
        resource: 'ag.spaces.addresses'
      }
    }
  },
  mounted () {
    if (this.getLocationsBySpaceId && this.getLocationsBySpaceId.length > 0) {
      this.space = this.getLocationsBySpaceId[0]
    }
  },
  computed: {
    ...mapGetters('identity', ['getLocationsBySpaceId']),
    spaceId () {
      return this.getObjectPath(this.space, 'id')
    },
    locations () {
      if (this.spaceId) {
        let remoteAddresses = this.getObjectPath(this.req, 'result.results', null)
        if (!remoteAddresses) {
          return this.getLocationsBySpaceId(this.spaceId)
        }
        return remoteAddresses
      }
      return []
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) { this.getAddresses() }
      }
    }
  },
  methods: {
    setContext (data) { this.space = data.data },
    getAddresses () {
      if (this.spaceId) {
        this.req.kwargs = {spaceId: this.spaceId}
        this.$request('get', this.req)
      }
    }
  }
}
</script>
